<template>
  <div>
    <div class="bars-title">Análisis de Rinde</div>
    <div class="bars-subtitle">
      <strong>Rinde de Equilibrio:</strong> qq/ha necesarios para cubrir los costos, conforme el precio de mercado <br>
      <strong>Rinde Presupuestado:</strong> qq/ha planteados para el modelo
    </div>
    <v-chart id="bar" :options="graph"/>
  </div>
</template>

<script>

import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/scatter'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/tooltip'

export default {
  name: 'bars',
  components: {'v-chart': ECharts},
  props: ['data','regions'],

  data() {
    return {
      graph :{
        grid: {
          top: 100,
          height: 250,
          left:'10%',
          bottom: 110
        },
        tooltip: {
          show: true,
          formatter: function (element) {
            const formatNumber = (value) => {
              if (value === null || value === undefined || value === '') return '';
              const num = Number(value);
              if (Number.isNaN(num)) return value;

              if (Number.isInteger(num)) return String(num).replace('.', ',');
              return num.toFixed(1).replace('.', ',');
            };
            let value = element.data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

            return formatNumber(value)+' qq/ha';
          }
        },
        xAxis: {
          type: 'category',
          data: this.regions,
          nameRotate: 90,
          axisLabel : {
            rotate: 90
          },
        },
        yAxis: {
          type: 'value',
          min: function(element) {
            return Math.round(element.min - (element.min * 0.05));
          },
          max: function(element) {
            return Math.ceil(element.max + (element.max * 0.05));
          },
          name: 'qq/ha',
          nameTextStyle: {
            fontSize: 14,
            color: '#3c4858',
            align: 'left'
          },
          axisLabel: {
            formatter: function (value) {
              value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
              //return value+' qq/ha'
              return value
            }
          },
          splitLine: {
            show: false
          },
        },
        textStyle: {
          fontFamily: 'Gotham-Book, Arial',
          color: '#888'
        },
        legend: {
          data:['Rinde de Equilibrio', 'Rinde Presupuestado'],
          top:30,
          itemGap: 30,
          orient: 'horizontal',
          textStyle: {
            fontSize: 12
          }
        },
        series: [
          {
            name: 'Rinde de Equilibrio',
            data: this.data.indif,
            type: 'bar',
            color: '#0961AF',
            barMaxWidth: 30,

          },
          {
            name: 'Rinde Presupuestado',
            data: this.data.pres,
            type: 'bar',
            color: '#249DA5',
            barMaxWidth: 30,
            barGap: '0%'
          }
        ]
      }
    }
  },
  methods: {
    changeLegendInMobileView() {
      this.graph.legend.textStyle.fontSize = 12;
      this.graph.legend.itemGap = 10;
      this.graph.legend.orient = 'vertical';

    },

    modifyChartInMobileView() {
      if (window.screen.width < 600) {
        this.changeLegendInMobileView();
      }
    },
  },
  mounted() {
    this.modifyChartInMobileView()
  }

}
</script>
<style>
    #bar{
        height: 550px;
    }
    .bars-title{
      font-family: Gotham-Book;
      font-size: 18px;
      color: '#5E5E5E';
      margin-bottom: 10px;
    }
    .bars-subtitle{
      font-family: Gotham-Book;
      font-size: 14px;
      line-height: 1.3em;
      color: '#777';
    }
    @media only screen and (max-width: 600px) {
      .bars-subtitle{
        font-size: 12px;
      }
    }
</style>
